import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FmlxIcon} from 'fmlx-common-ui';
import SerialDilutionDeckSelectionButton from './SerialDilutionDeckSelectionButton';
import Tube from '../Components/Tube/Tube';

function SerialDilutionImage({
  imgStyle,
  imgPath,
  imgRef,
  isTubeComponent,
  tubeComponenProps,
  isFilled,
  labelImg,
  label,
  deckInsertNumber,
  onClick,
  onDelete,
  isRequired,
}) {
  const [hover, setHover] = useState(false);
  const deletable = isFilled;
  return (
    <div className="serial-dilution__tube">
      <div className="serial-dilution__tube__image">
        {isTubeComponent ? (
          <Tube
            deletable={isFilled}
            onDelete={onDelete}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...tubeComponenProps}
            tubeOpacity={isFilled ? 1 : 0.5}
            ref={imgRef}
          />
        ) : (
          <div
            key={imgPath}
            onMouseOver={() => {
              if (!hover) {
                setHover(true);
              }
            }}
            onMouseLeave={() => {
              setHover(false);
            }}
          >
            <div className="serial-dilution__tube__image__wrapper">
              {deletable && hover && (
                <div
                  className={`serial-dilution__tube__delete tube-delete ${imgPath}`}
                  onClick={onDelete}
                  role="presentation"
                >
                  <FmlxIcon name="Trash" customColor="#4E4BFF" size="xs" />
                </div>
              )}
              <img
                className="serial-dilution__tube__image--svg"
                style={{opacity: isFilled ? 1 : 0.5, ...imgStyle}}
                src={`./svg/serial-dilution/${imgPath}-${isFilled ? 'filled' : 'empty'}.svg`}
                alt="sample-source-empty"
                ref={imgRef}
              />
            </div>
          </div>
        )}
      </div>
      <SerialDilutionDeckSelectionButton
        label={labelImg}
        labelButton={label}
        labelWell={label[0]?.wells ?? ''}
        deckInsertNumber={deckInsertNumber}
        onClick={onClick}
        maxLabelLength={20}
        isRequired={isRequired}
      />
    </div>
  );
}

SerialDilutionImage.propTypes = {
  imgPath: PropTypes.string.isRequired,
  imgRef: PropTypes.object,
  labelImg: PropTypes.string.isRequired,
  isTubeComponent: PropTypes.bool,
  tubeComponenProps: PropTypes.object,
  isFilled: PropTypes.bool,
  deckInsertNumber: PropTypes.string,
  label: PropTypes.array,
  imgStyle: PropTypes.object,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  isRequired: PropTypes.bool,
};

SerialDilutionImage.defaultProps = {
  isFilled: false,
  isTubeComponent: false,
  isRequired: false,
  tubeComponenProps: {},
  deckInsertNumber: null,
  label: [],
  imgStyle: {},
  imgRef: null,
  onClick: () => {},
  onDelete: () => {},
};

export default SerialDilutionImage;
